<template>
  <a-modal v-model="visible" :afterClose="resetModal" :title="title">
    <a-form-model ref="deleteForm" :model="confirmMove" :rules="rules">
      <a-form-model-item prop="companyName" label="Company Name">
        <a-input size="large" v-model="confirmMove.companyName">
          <a-icon slot="prefix" type="bank" class="input-ico n" />
        </a-input>
      </a-form-model-item>
       <a-form-model-item prop="tempPass" label="Temporary Password">
        <a-input-password size="large"  v-model="confirmMove.tempPass" >
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item
        label="New Instance Manager Server"
        prop="newInstanceManagerId"
      >
        <a-select v-model="confirmMove.newInstanceManagerId" style="width: 100%">
          <a-select-option
            v-for="instanceManager in instanceManagerList"
            :key="instanceManager.id"
            :value="instanceManager.id"
          >
            {{ instanceManager.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button
        @click="ok"
        type="primary"
        :loading="loading"
        :disabled="!formIsValid"
        >Move</a-button
      >
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>
<script>
import {
  instanceManagerState,
  instanceManagerMutations,
} from "../../Store/store.js";

export default {
  props: {
    value: Boolean,
    companyName: String,
    oldInstanceManager: {},
    companyId: Number,
    loading: Boolean,
  },
  data() {
    return {
      instanceManagerMutations,
      instanceManagerState,
      confirmMove: {
        companyName: "",
        companyId: "",
        oldInstanceManagerId: "",
        newInstanceManagerId: "",
      },
      rules: {
        newInstanceManagerId: [
          {
            required: true,
            message: "Please select instance manager server",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: "Please input your Company Name!",
            trigger: "blur",
          },
        ],
         tempPass: [
          {
            required: true,
            message: "Please input your Temporary Password!",
            trigger: "blur",
          }
          ]
      },
      instanceManagerList: [],
    };
  },
  computed: {
    formIsValid: function () {
      return this.confirmMove.companyName !== "" && 
             this.confirmMove.companyName == this.companyName &&
             this.confirmMove.newInstanceManagerId;
    },
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    title: {
      get() {
        if (!this.oldInstanceManager) return "";
        return `Move Instance '${this.companyName}' from '${this.oldInstanceManager.name}'`;
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.instanceManagerList = instanceManagerState.instantManagers.filter(
          (i) => i.id !== this.oldInstanceManager.id
        );
      }
    },
  },
  async mounted() {
    await this.instanceManagerMutations.setInstanceManager({});
  },
  methods: {
    cancel() {
      this.visible = false;
    },
    ok() {
      this.$refs.deleteForm.validate(async (valid) => {
        if (valid) {
          this.confirmMove.oldInstanceManagerId = this.oldInstanceManager.id;
          this.confirmMove.companyId = this.companyId;
          this.$emit("moveInstance", this.confirmMove);
        }
      });
    },
    resetModal() {
      this.confirmMove = {
        companyName: "",
        companyId: "",
        oldInstanceManagerId: "",
        newInstanceManagerId: "",
        tempPass:""
      };
    },
  },
};
</script>
